/** Shared types between frontend and Cloudflare Worker */

export type Plan = 'free' | 'pro'
export type BillingInterval = 'month' | 'year'
export type SubscriptionStatus = 'active' | 'canceled' | 'past_due' | 'trialing'
export type Language = 'zh' | 'en'

export interface User {
  id: string
  email: string
  createdAt: number
  /** null = 用户未显式设置过语言，前端按浏览器语言自动展示 */
  language: Language | null
}

export interface Subscription {
  plan: Plan
  billingInterval: BillingInterval | null
  status: SubscriptionStatus
  currentPeriodEnd: number | null
  /** Stripe cancel_at_period_end：已取消但周期内仍可用 */
  cancelAtPeriodEnd: boolean
}

export interface AuthUser extends User {
  plan: Plan
  subscription: Subscription
}

export interface AuthTokenResponse {
  token: string
  user: AuthUser
}

/** 云端同步的游戏状态（不含棋盘网格，网格仍走本地 localStorage） */
export interface GameStatePayload {
  mode: string
  currentLevel: number
  totalScore: number
  currentScore: number
  highestNumber: number
  isLevelCompleted: boolean
  moves: number
  tools: unknown[]
  language: string
  diamonds: number
  soundOn: boolean
}

/** Pro 额外每日钻石奖励（示意权益） */
export const PRO_DAILY_DIAMOND_BONUS = 10
export const FREE_INITIAL_DIAMONDS = 20
